import { useQuery } from '@tanstack/react-query';

import { Collections } from '@graylog/enterprise-api';

import { defaultOnError } from 'util/conditional/onError';
import type FetchError from 'logic/errors/FetchError';

import { COLLECTIONS_QUERY_KEY } from './useCollections';

type Options = {
  enabled: boolean;
};

export const fetchEntityByCollection = async (entityGRNs: Array<string>) =>
  Collections.getStatuses({ entity_grns: entityGRNs });

export const keyFn = (entityGRN: Array<string>) => [COLLECTIONS_QUERY_KEY, 'entity', entityGRN];

const useEntityCollections = (
  entityGRNs: Array<string>,
  { enabled }: Options = { enabled: true },
): {
  data: {
    [key: string]: Array<{ id: string; title: string }>;
  };
  refetch: () => void;
  isLoading: boolean;
  error: FetchError;
} => {
  const {
    data,
    refetch,
    isPending: isLoading,
    error,
  } = useQuery<any, FetchError>({
    queryKey: keyFn(entityGRNs),
    queryFn: () =>
      defaultOnError(
        fetchEntityByCollection(entityGRNs),
        'Loading collection by entity failed with status',
        'Could not load collection by entity.',
      ),
    notifyOnChangeProps: ['data', 'error'],
    enabled,
  });

  return {
    data,
    refetch,
    isLoading,
    error,
  };
};

export default useEntityCollections;
